import { createEntityAdapter, EntityAdapter, EntityState } from '@ngrx/entity';
import { Template } from '@quorum/models/xs-resource';

export interface SelectedTemplateState extends EntityState<Template> {}

export const TemplateAdapter: EntityAdapter<Template> = createEntityAdapter<Template>({
  selectId: (Template: Template) => Template.id,
});
export const initialTemplateState: SelectedTemplateState = TemplateAdapter.getInitialState({});
